module.exports = __webpack_public_path__ + "static/img/e_picture.9e664a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/e_picture.png
// module id = pWdN
// module chunks = 3